import { Box } from 'ui/box';

import { getFilterDisplayName } from 'constants/report-filters-mapping';

export interface FavoriteReportFilter {
  column: string;
  values: unknown[];
  [key: string]: unknown;
}

interface FilterItemProps {
  filter: FavoriteReportFilter;
}

const FilterItem = ({ filter }: FilterItemProps): React.JSX.Element => {
  const formatFilterValue = (values: unknown[] | undefined): string => {
    if (!Array.isArray(values) || values.length === 0) {
      return 'No value';
    }

    return values.join(', ');
  };

  return (
    <Box
      sx={{
        width: 'fit-content',
        display: 'inline-block',
        borderWidth: '1px',
        borderColor: 'tokens.navy.200',
        borderRadius: '0.25rem',
        px: 1,
        py: 0.5,
        fontSize: '0.875rem',
        lineHeight: '1.25rem',
        color: 'tokens.gray.500',
      }}
    >
      {getFilterDisplayName(filter.column)}: {formatFilterValue(filter.values)}
    </Box>
  );
};

export default FilterItem;
